import React from 'react';
import { GUARANTEE } from '../constants/content';
import { Reveal } from './Reveal';
export function Guarantee() {
  return <section className="w-full bg-cream py-12 b760:py-16" data-id="element-111" data-mp="1o2vi2rco2r7m">
      <div className="mx-auto max-w-3xl px-4 b720:px-6" data-id="element-112" data-mp="223685s65k1rq">
        <Reveal className="text-center" data-id="element-113" data-mp="222n156i1ixsh">
          <h2 className="mx-auto max-w-2xl font-display text-2xl font-700 uppercase leading-tight text-night b640:text-4xl" data-id="element-114" data-mp="1x4lao0iabw6z">
            {GUARANTEE.title}
          </h2>
          <div className="mx-auto mt-5 max-w-2xl space-y-4" data-id="element-115" data-mp="19co4oq1inyds">
            {GUARANTEE.paragraphs.map(paragraph => <p key={paragraph} className="text-sm leading-relaxed text-night/85 b640:text-base" data-id="element-116" data-mp="1j4k9sl20sori">
                {paragraph}
              </p>)}
          </div>
        </Reveal>

        <Reveal className="mt-8" data-id="element-117" data-mp="qn7x5irez5nv">
          <div className="rounded-2xl border-2 border-mustard bg-white p-6 text-center b640:p-8" data-id="element-118" data-mp="qm6gmyrmpqyr">
            <p className="text-4xl" aria-hidden="true" data-id="element-119" data-mp="ln28mbgfxza0">
              {GUARANTEE.badge}
            </p>
            <h3 className="mt-3 font-display text-xl font-700 uppercase leading-tight text-bordo b640:text-2xl" data-id="element-120" data-mp="oxf7m220gbov">
              {GUARANTEE.boxTitle}
            </h3>
            <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-night/85 b640:text-base" data-id="element-121" data-mp="yqmang9a3fls">
              {GUARANTEE.boxBody}
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}